import "./DashboardHeaderHamburger.css";

import { MenuOutlined } from "@ant-design/icons";
import { Button, ConfigProvider } from "antd";
import React from "react";

interface DashboardHeaderHamburgerProps {
  onMenuClick: () => void;
}

const DashboardHeaderHamburger: React.FC<DashboardHeaderHamburgerProps> = ({
  onMenuClick,
}) => {
  return (
    <div className="dashboard-header-hamburger">
      <ConfigProvider
        theme={{
          components: {
            Button: {
              paddingContentHorizontal: 10,
            },
          },
        }}
      >
        <Button type="text" onClick={() => onMenuClick()}>
          <MenuOutlined
            style={{
              fontSize: 20,
            }}
          />
        </Button>
      </ConfigProvider>
    </div>
  );
};

export default DashboardHeaderHamburger;
